<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>

    <section style="float:left;">
      <el-select v-model="deviceCategoryId" size="small" style="margin-left:1rem;">
        <el-option :value="null" label="所有仪器类别" />
        <el-option
          v-for="deviceCategory in deviceCategories"
          :key="deviceCategory.id"
          :value="deviceCategory.id"
          :label="deviceCategory.name"
        />
      </el-select>
    </section>
  </template>

  <template #toolbar>
    <section class="toolbar-btn">
      <el-button
        v-if="isAdmin"
        type="orange"
        size="small"
        @click="onSyncBtnClick"
      >同步{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <el-table
      ref="table"
      :data="filterList"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @row-click="onSelectDevice"
    >
      <el-table-column label="序号" width="50">
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>
      <el-table-column prop="name" label="设备名称" />
      <el-table-column prop="brand" label="设备品牌" />
      <el-table-column prop="model" label="设备型号" />
      <el-table-column prop="deviceCategoryId" label="设备类型">
        <template slot-scope="{row}">{{(deviceCategoryMap[row.deviceCategoryId] || {}).name}}</template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="{row}">
          <div class="table-operator-wrapper">
            <span class="table-operator-btn edit-btn" @click.stop="onOpenEditor(row)">
              <i class="el-icon-edit" aria-hidden="true"></i>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </template>

  <template #editor>
    <editor
      ref="editor"
      @save="onDeviceSave"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../../BaseListEditor'
import Editor from './Editor'
import {DEVICE_SELECT_CHANGED} from './EventKeys'

export default {
  name: 'index',
  routeInfo: {
    label: '设备管理',
    icon: 'fa fa-wheelchair-alt',
    curdInfo: {
      api: 'Device',
      id: 'id',
      name: 'name',
      editName: '设备'
    }
  },
  extends: BaseListEditor,
  components: {
    Editor
  },
  data () {
    return {
      model: {},
      deviceCategoryId: null,
      rowList: [],
      formLabelWidth: '800px'
    }
  },
  computed: {
    filterList () {
      let {deviceCategoryId} = this
      return deviceCategoryId === null ? this.list : this.list.filter(device => device.deviceCategoryId === deviceCategoryId)
    }
  },
  methods: {
    onSelectDevice (device) {
      this.selectDevice(device)
    },
    selectDevice (org) {
      let {currentOrg} = this

      if (!currentOrg || currentOrg.id !== org.id) {
        this.currentOrg = org
        this.$eventBus.emit(DEVICE_SELECT_CHANGED, org)
      }

      this.$nextTick(() => {
        let table = this.getTable()

        if (table) {
          let id = org.id
          let tableData = table.tableData.find(org => org.id === id)
          table.setCurrentRow(tableData)
        }
      })
    },
    onDeviceSave (device) {
      this.device = device
      this.getList()
    },
    afterQuery () {
      let {device} = this

      if (device) {
        this.selectDevice(device)
        this.device = null
      } else {
        let {list} = this
        this.selectDevice(list.length > 0 ? list[0] : {
          id: null
        })
      }
    },
    onSyncBtnClick () {
      this.changeLoadStatus(true)
      this.$api.Device.syncCloud().then(() => {
        this.$notify({
          title: '成功',
          message: '同步成功',
          type: 'success',
          position: 'bottom-right'
        })

        this.$store.dispatch('DeviceCategory/request')
        this.$store.dispatch('FactorGroup/request')
        this.$store.dispatch('Factor/request')
        this.getList()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.table-operator-wrapper {
  display: inline-block;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/03Device/DeviceList.vue